// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__35Shi","badges":"styles_badges__2FP1H"};